import {TimelineLite} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Game} from "../Game";

export class TotalWinRunner implements SimplePresentation {
    private _tl: TimelineLite;


    shouldRun(): boolean {
        const winAmt: number = Game.model.isBonus() ? Game.model.gameData.totalSpinWinnings : Game.model.data.accumulatedRoundWin;
        return winAmt > 0 && !Game.model.isBigWin;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._tl = new TimelineLite({
            onComplete: () => {
                this.complete(controller);
            }
        });
        this._tl.add(() => {
            controller.setSkipCallback(() => this.onSkip(controller));
        }, 0.001);
        this._tl.add(Game.totalWinView.getTotalWinTimeline(Game.model.getWinAmount()), 0);
    }

    private complete(controller: SimplePresentationRunnerController): void {
        if (!Game.model.gameData.brokeTheBank) {
            Game.keypadPlugin.setWin(Game.model.gameData.accumulatedRoundWin, true, Game.isWinBelowStake());
        }

        controller.finish();
    }

    private onSkip(controller: SimplePresentationRunnerController): void {
        controller.setSkipCallback(undefined)
        this._tl.progress(1);
        Game.totalWinView.hardAbort(Game.model.getWinAmount());
    }
}